export const supportedStores = [
    { key: 'x-kom', name: 'x-kom', domain: 'x-kom.pl' },
    { key: 'morele', name: 'Morele', domain: 'morele.net' },
    { key: 'media-expert', name: 'Media Expert', domain: 'mediaexpert.pl' },
    { key: 'rtv-euro-agd', name: 'RTV Euro AGD', domain: 'euro.com.pl' },
    { key: 'komputronik', name: 'Komputronik', domain: 'komputronik.pl' },
    { key: 'amazon-pl', name: 'Amazon.pl', domain: 'amazon.pl' },
];
// Amazon changes marketing slugs and /ref=... paths without changing the product.
// Seller-specific links and distinct ASINs must remain independent.
export function offerUrlKey(raw) {
    try {
        const url = new URL(raw);
        url.hash = '';
        if (url.protocol === 'https:' && !url.username && !url.password && !url.port && ['amazon.pl', 'www.amazon.pl'].includes(url.hostname)) {
            const asin = url.pathname.match(/\/(?:dp|gp\/product)\/([A-Z0-9]{10})(?:\/|$)/)?.[1];
            if (asin)
                return 'amazon-pl:' + asin + ':' + ['m', 'smid', 'seller'].map(key => url.searchParams.get(key) ?? '').join('|');
        }
        return url.href;
    }
    catch {
        return raw;
    }
}
export function isValidEan(value) {
    if (!/^\d{8}$|^\d{13}$/.test(value))
        return false;
    const digits = [...value].map(Number);
    const checksum = digits.slice(0, -1).reverse().reduce((sum, digit, index) => sum + digit * (index % 2 === 0 ? 3 : 1), 0);
    return (10 - checksum % 10) % 10 === digits.at(-1);
}
